import { GoogleOAuthProvider } from '@react-oauth/google';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
// import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import store from './store';
import { hydrate, render } from 'react-dom';

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );

const rootElement = document.getElementById("root") as HTMLElement;

if (rootElement.hasChildNodes()) {
  hydrate((
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID ?? ''}>
      <Provider store={store}>
        <App />
      </Provider>
    </GoogleOAuthProvider>
  ), rootElement);
} else {
  const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
  root.render((
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID ?? ''}>
      <Provider store={store}>
        <App />
      </Provider>
    </GoogleOAuthProvider>
  ))
  // render((
  //   <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID ?? ''}>
  //     <Provider store={store}>
  //       <App />
  //     </Provider>
  //   </GoogleOAuthProvider>
  // ), rootElement);
}
// root.render(
  
  
// );

reportWebVitals();
